import {Injectable} from '@angular/core';
import { DdsConfigOptions } from '@usitsdasdesign/dds-ng/shared/dds-config';
import { ErrorState, LabelPosition, PositionState, Size, Themes } from '@usitsdasdesign/dds-ng/shared';
import { ToastOptions } from '@usitsdasdesign/dds-ng/toast';

@Injectable()
export class CommonConfig {
    static datesFormat = {
        placeholder: 'MM/DD/YYYY',
        date: 'MM/dd/yyyy',
        mDate: 'MM/DD/YYYY',
        full: 'MM/dd/yyyy, hh:mm a',
        mFull: 'MM/DD/YYYY, hh:mm A',
        time: 'hh:mm a',
        mTime: 'hh:mm A',
        timePlaceholder: 'HH:MM AM'
    };

  static ddsConfigOptions: DdsConfigOptions = {
    theme: Themes.dark,
    size: Size.md,
    isResponsive: false,
    labelPosition: LabelPosition.external,
    stickerPosition: PositionState.bottomLeft,
    stickerIndent: 0,
    errorState: ErrorState.focusOut,
  };

  static toastOptions: ToastOptions = {
    lifeTime: 5000,
    position: 'bottom-center',
    isCloseIcon: false,
    limit: 5,
    theme: CommonConfig.ddsConfigOptions.theme,
  };

}
